
<!--
  功能：报表-电商报表
-->
<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: 'ecReport'
}
</script>



// WEBPACK FOOTER //
// src/views/report/ecReport/ecReport.vue